'use client';
import { useSiteId } from '@/contexts/domain/hooks';
import type { SiteId } from '@/features/basket/types/site';
import { clsx } from 'clsx';
import { useLocale, useTranslations } from 'next-intl';
import { Fragment } from 'react';

interface Props {
  amount?: number;
  className?: string;
  currencyClassName?: string;
  textFree?: boolean;
  testId?: string;
}

export const currencyMap: Record<SiteId, string> = {
  wp_pl: 'PLN',
  ld_lt: 'EUR',
  ds_lv: 'EUR',
  kg_ee: 'EUR',
  el_fi: 'EUR',
};

const Currency = ({
  amount,
  className = 'font-semibold',
  currencyClassName = 'font-normal text-muted',
  textFree = false,
  testId,
}: Props) => {
  const localeData = useLocale();
  const locale = localeData === 'ee' ? 'et' : localeData;
  const siteId = useSiteId();
  const t = useTranslations('common');

  if (textFree && amount !== undefined && amount < 0.01) {
    return <div className={className}>{t('free_lc')}</div>;
  }

  const formattedParts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyMap[siteId] ?? 'PLN',
  }).formatToParts(amount);

  return (
    <div className={clsx('tabular-nums', className)} data-testid={testId}>
      {formattedParts.map(({ type, value }) => {
        if (type === 'currency') {
          return (
            <span key={`${value}+${type}`} className={currencyClassName}>
              {value}
            </span>
          );
        }

        return <Fragment key={`${value}+${type}`}>{value}</Fragment>;
      })}
    </div>
  );
};

export default Currency;
